import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {StyleService} from '../../../Services/style.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-archive-style-view',
  templateUrl: './archive-style-view.component.html',
  styleUrls: ['./archive-style-view.component.scss']
})
export class ArchiveStyleViewComponent implements OnInit {
  public grid: Grid;
  public styleId: number;
  public styleName: string;

  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private styleService: StyleService,
    private broadcastService: BroadcastService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.style.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.styleId = row.id;
                this.styleName = row.name.bold();
                this.readdModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.styleService,
      rememberURL: this.router.url,
      method: 'getStyle',
      defaultSort: 'position',
      // rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      archive: true,
    };
  }

  readdStyle() {
    this.styleService.reAddStyle(this.styleId).subscribe(res => {
      this.broadcastService.broadcast('refreshGrid', 'getStyle');
      this.readdModal.hide();
    });
  }

}
